// Relative imports, not the barrel (React, web-vitals): the early binding imports this module before its listener exists. ./early-import-wall.test.ts enforces it.
import { parseLogBackend } from "../backend-choice";
import { ConsoleLogBackend } from "../backends/console";
import type { LogBackend } from "../backends/interface";
import { MultiLogBackend } from "../backends/multi";
import { WorkerLogBackend } from "../backends/worker";

// One backend per page, not per Logger: WorkerLogBackend can only count its own requests against the per-document 64 KiB keepalive quota, so many instances each assumed the whole quota and overflowed at page hide.
function buildPageBackend(
  configured: unknown,
  settingName: string,
): LogBackend {
  const choice = parseLogBackend(configured);

  // parseLogBackend falls back to console; warn so a typo like "axiom " is not a silent no-op.
  if (configured !== undefined && configured !== "" && configured !== choice) {
    console.warn(
      `[logging] ignoring ${settingName}=${JSON.stringify(configured)} — logging through "${choice}" instead`,
    );
  }

  switch (choice) {
    case "console":
      return new ConsoleLogBackend();
    case "axiom":
      return new WorkerLogBackend();
    case "both":
      return new MultiLogBackend([
        new WorkerLogBackend(),
        new ConsoleLogBackend(),
      ]);
  }
}

export function createPageBackend(
  readConfigured: () => unknown,
  settingName: string,
): () => LogBackend {
  let pageBackend: LogBackend | null = null;
  return () => {
    pageBackend ??= buildPageBackend(readConfigured(), settingName);
    return pageBackend;
  };
}
